import { Injectable } from "@angular/core";
import { CalendarApi } from "../../../shared/nestjs/gd-only/services/calendar.api";


@Injectable()
export class CalendarBloc {

    constructor(
        public calendarNestApi: CalendarApi,
    ) {

    }

    getCalendar(payload: { year: number, month: number }) {
        return this.calendarNestApi.getCalendar(payload)
    }

    async getCalendarDetail(payload: { id: string }) {
        try {
            return this.calendarNestApi.getCalendarDetail(payload).map(params => params.data).toPromise();
        } catch (error) {
            throw error;
        }
    }

    async setStatusParticipant(payload: { calendarId: string, status: any, notes: any }) {
        try {
            return this.calendarNestApi.setStatusParticipant(payload).map(params => params.data).toPromise();
        } catch (error) {
            throw error;
        }
    }

    searchParticipant(payload: any) {
        return this.calendarNestApi.searchParticipant(payload)
    }
ƒ
    async setCalendar(payload: any) {
        try {
            return this.calendarNestApi.setCalendar(payload).map(params => params.data).toPromise();
        } catch (error) {
            throw error;
        }
    }

    async checkParticipantCalendar(payload: { empIds: any, startDate: any, endDate: any }) {
        try {
            return this.calendarNestApi.checkParticipantCalendar(payload).map(params => params.data).toPromise();
        } catch (error) {
            throw error;
        }
    }

}



// WEBPACK FOOTER //
// ./src/bloc/feature/calendar/calendar.bloc.ts